var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:{'small': _vm.size=='sm', 'medium': _vm.size=='md', 'heigh': _vm.size=='lg'},attrs:{"type":_vm.type,"placeholder":_vm.ph},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.update($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }